namespace $ {
	export class $shm_hitalama_benchmarks_archive_catalog extends $giper_baza_dict_to(
		$giper_baza_atom_link.to(()=> $shm_hitalama_benchmarks_catalog_run),
	) {}
}
